export default __webpack_public_path__ + "1c551c6acdc3e42cfde056fa9124a325.jpg";